import { objectKeys } from '@/utils';
import { createTask, getGroupValues} from '../../Applications/helpers';

export function numberDayTask() {
  let arr = [];
  for (let i = 1; i <= 31; i += 1) {
    arr.push({
      value: i,
      label: i.toString(),
    })
  }
  return arr;
}

export const handleSubmit = async (data: any, navigate: (e:string)=>void,site_configuration: Record<string, any>) => {
  const formData = new FormData();
  // eslint-disable-next-line consistent-return
  objectKeys(data).forEach((key: string) => {
    if (data[key]) {
      if (key === 'groups') {
        getGroupValues(data[key]).map((item) => {
          return (
              formData.append('groups', String(item))
          )
        })
      }
      else if(key === 'user' || key === 'client') {
        return (
            formData.append(key, data[key].value)
        )
      }
      else{
        return (
            formData.append(key, data[key])
        )
      }
    }
  })
  try {
    await createTask(formData)
    navigate(site_configuration?.page_tasks)
  } catch (e) {
    console.log(e);
  }
}